/**
 * Embeds Management Page
 * Module 07 - Dashboard UI
 */

import React, { useState } from 'react';
import { Plus } from 'lucide-react';
import EmbedsList from '../components/Embeds/EmbedsList';
import CreateEmbedModal from '../components/Embeds/CreateEmbedModal';
import Button from '../components/common/Button';
import { useModels, useEmbeds } from '../hooks';

const Embeds: React.FC = () => {
  const [createModalOpen, setCreateModalOpen] = useState(false);
  const { models } = useModels();
  const { embeds } = useEmbeds();

  // Filter only ready models for embed creation
  const readyModels = models.filter((m) => m.status === 'ready');

  const handleCreateSuccess = () => {
    setCreateModalOpen(false);
    // Embeds list will automatically refresh via React Query
  };

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Your Embeds</h1>
          <p className="mt-1 text-sm text-gray-500">
            {embeds.length} {embeds.length === 1 ? 'embed' : 'embeds'} • Create and manage your 3D viewer embeds
          </p>
        </div>
        <Button
          onClick={() => setCreateModalOpen(true)}
          className="flex items-center gap-2"
          disabled={readyModels.length === 0}
        >
          <Plus className="h-5 w-5" />
          Create Embed
        </Button>
      </div>

      {/* No Models Warning */}
      {readyModels.length === 0 && (
        <div className="card bg-yellow-50 border-yellow-200">
          <p className="text-sm text-yellow-800">
            You need to upload and process at least one model before creating embeds.
          </p>
        </div>
      )}

      {/* Embeds List */}
      <EmbedsList />

      {/* Create Modal */}
      <CreateEmbedModal
        open={createModalOpen}
        onClose={() => setCreateModalOpen(false)}
        onSuccess={handleCreateSuccess}
        models={readyModels}
      />
    </div>
  );
};

export default Embeds;
